import React from 'react';
import { PhoneType } from '@isyc-react/types';
import { personPhoneToPhoneItem, phoneItemToPersonPhone } from '@isyc-react/form/modules/input/phone';
import { dayjs, formatToIsoStringUTC } from '@isyc-react/form/modules/date';
import { dateFormatString } from 'common-app/options';
export const parametersToRecordByCode = (parameters) => {
    var _a;
    return (_a = parameters === null || parameters === void 0 ? void 0 : parameters.reduce((sum, param) => {
        sum[param.code] = param;
        return sum;
    }, {})) !== null && _a !== void 0 ? _a : {};
};
export const bailleursPhoneToPhoneItem = (phone) => personPhoneToPhoneItem(Object.assign(Object.assign({}, phone), { principal: false, type: PhoneType.mobile }));
export const bailleursPhoneItemToPhone = (phone) => {
    const phoneApi = phoneItemToPersonPhone(phone);
    if (phoneApi) {
        return { number: phoneApi.number, prefix: phoneApi.prefix };
    }
    return null;
};
export const useIsAdult = (watchBirthDate, dateFormatString) => {
    const isAdult = React.useMemo(() => {
        if (watchBirthDate) {
            const isoBirthDate = formatToIsoStringUTC(watchBirthDate, dateFormatString);
            if (isoBirthDate) {
                const birthDate = new Date(isoBirthDate);
                const currentDate = new Date();
                const birthDateYear = birthDate.getFullYear();
                const currentDateYear = currentDate.getFullYear();
                return currentDateYear - birthDateYear >= 18;
            }
        }
        return false;
    }, [watchBirthDate]);
    return isAdult;
};
export const getIsMinDateAllowed = (dateSelected) => {
    const minDate = dayjs('31/12/1910', dateFormatString);
    const actualDate = dayjs(dateSelected, dateFormatString);
    return actualDate.isAfter(minDate);
};
export const getIsLegalAgeDateAllowed = (dateSelected) => {
    const actualYear = dayjs().get('year');
    const minLegalYear = actualYear - 17;
    const minDateStr = `01/01/${minLegalYear}`;
    const actualDate = dayjs(dateSelected, dateFormatString);
    const minDate = dayjs(minDateStr, dateFormatString);
    return actualDate.isBefore(minDate);
};
export const getFutureDateAllowed = (dateSelected) => {
    const futureDate = new Date();
    const actualDate = dayjs(dateSelected, dateFormatString);
    return actualDate.isBefore(futureDate);
};
